import React, { useState } from 'react';
import { CountdownTimer } from './CountdownTimer';
interface PricingOption {
  id: string;
  emoji: string;
  title: string;
  description: string;
  originalPrice: string;
  price: string;
  ctaText: string;
  ctaHref: string;
  isFeatured?: boolean;
  savings?: string;
}
const options: PricingOption[] = [{
  id: 'megapack',
  emoji: '📘',
  title: 'MEGAPACK NATACIÓN LISTO',
  description: '6 Tomos + 6 Bonos',
  originalPrice: 'USD 24,90',
  price: 'USD 13,90',
  ctaText: '→ SÍ, QUIERO EL MEGAPACK',
  ctaHref: 'https://docentes2.edulabs.online/cart/43294111924342:1'
}, {
  id: 'elite',
  emoji: '🏆',
  title: 'MEGAPACK + NATACIÓN BUSINESS PRO',
  description: '6 Tomos + 6 Bonos + Natación Business Pro™ (Retención · Autoridad con Padres · Marketing · Rentabilidad)',
  originalPrice: 'USD 31,90',
  price: 'USD 19,90',
  ctaText: '→ SÍ, QUIERO EL MEGAPACK + NATACIÓN BUSINESS PRO',
  ctaHref: 'https://docentes2.edulabs.online/cart/43294112022646:1',
  isFeatured: true,
  savings: 'AHORRAS USD 12'
}];
export function PricingSection() {
  const [selected, setSelected] = useState('elite');
  const selectedOption = options.find(o => o.id === selected)!;
  return <section id="pricing" className="w-full bg-[#0A0A0F] py-12 sm:py-16 px-4" data-id="element-132">
      <div className="max-w-lg mx-auto" data-id="element-133">
        {/* Header */}
        <div className="text-center mb-6" data-id="element-134">
          <h2 className="text-2xl sm:text-3xl font-black text-white mb-1" data-id="element-135">
            Elegí tu <span className="text-[#FF6B00]" data-id="element-136">MegaPack</span>
          </h2>
          <p className="text-[#B0B0C0] text-xs sm:text-sm" data-id="element-137">
            Ambas opciones incluyen los 6 bonos estratégicos
          </p>
        </div>

        {/* Options */}
        <div className="space-y-3 mb-5" data-id="element-138">
          {options.map(option => {
          const isSelected = selected === option.id;
          const isFeatured = option.isFeatured;
          return <button key={option.id} onClick={() => setSelected(option.id)} className={`w-full text-left rounded-xl p-4 sm:p-5 transition-all bg-[#16161F] relative overflow-hidden ${isSelected && isFeatured ? 'border-2 border-[#FF6B00] shadow-[0_0_40px_rgba(255,107,0,0.12)]' : isSelected ? 'border-2 border-[#FF6B00]' : 'border border-[#333340]'}`} data-id="element-139">
                {isFeatured && <div className="absolute top-0 right-0 bg-[#FFD700] text-[#0A0A0F] text-[9px] sm:text-[10px] font-black px-3 py-0.5 rounded-bl-lg" data-id="element-140">
                    ⭐ MÁS ELEGIDO
                  </div>}

                <div className="flex items-center gap-3" data-id="element-141">
                  <div className={`w-5 h-5 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${isSelected ? 'border-[#FF6B00]' : 'border-[#333340]'}`} data-id="element-142">
                    {isSelected && <div className="w-2.5 h-2.5 rounded-full bg-[#FF6B00]" data-id="element-143" />}
                  </div>

                  <div className="flex-1 min-w-0" data-id="element-144">
                    <div className="flex items-center gap-2" data-id="element-145">
                      <span className="text-base" data-id="element-146">{option.emoji}</span>
                      <span className="text-white font-bold text-sm sm:text-base" data-id="element-147">
                        {option.title}
                      </span>
                    </div>
                    <p className="text-[#B0B0C0] text-xs mt-1" data-id="element-148">
                      {option.description}
                    </p>
                    {option.savings && <span className="inline-block bg-[#FF6B0033] text-[#FF6B00] text-[10px] font-bold px-2 py-0.5 rounded-full mt-1.5" data-id="element-149">
                        {option.savings}
                      </span>}
                  </div>

                  <div className="text-right flex-shrink-0" data-id="element-150">
                    <div className="text-[#B0B0C0] line-through text-[10px] sm:text-xs" data-id="element-151">
                      {option.originalPrice}
                    </div>
                    <div className="font-black text-xl sm:text-2xl text-white" data-id="element-152">
                      {option.price}
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* Mini countdown */}
        <div className="flex items-center justify-center gap-2 mb-4" data-id="element-153">
          <span className="text-[#FF6B00] text-xs font-bold" data-id="element-154">
            ⏰ Precio de lanzamiento termina en
          </span>
          <CountdownTimer size="sm" blinking={false} data-id="element-155" />
        </div>

        {/* CTA Button */}
        <a href={selectedOption.ctaHref} className="btn-primary-pulse block w-full text-center bg-[#FF6B00] font-black text-base sm:text-lg py-4 rounded-xl hover:bg-[#ff8533] transition-colors text-white mb-3" data-id="element-156">
          {selectedOption.ctaText}
        </a>

        {/* Sub-CTA info */}
        <p className="text-[#B0B0C0] text-[10px] sm:text-xs text-center mb-5" data-id="element-157">
          💱 Pagarás en tu moneda local · Conversión automática desde USD
        </p>

        {/* Trust bar */}
        <div className="flex flex-wrap items-center justify-center gap-3 text-[10px] sm:text-xs text-[#B0B0C0]" data-id="element-158">
          <span data-id="element-159">🔒 Pago seguro</span>
          <span data-id="element-160">⚡ Acceso en 5 min</span>
          <span data-id="element-161">🛡️ Garantía 7 días</span>
          <span data-id="element-162">💳 Tarjeta · PayPal</span>
        </div>
      </div>
    </section>;
}